import './section.scss';

import React from 'react';

type SectionProps = {
    section: any;
    children?: any;
    className?: string;
};

export default function Section(props: SectionProps) {
    const { section, children, className } = props;

    return (
        <section className={className}>
            <div
                className={`heading container ${
                    section.align && section.align
                }`}
            >
                <h2>{section.title}</h2>
                <p>{section.subtitle}</p>
            </div>

            {children}
        </section>
    );
}
